import {Component, OnDestroy, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';

@Component({
  selector: 'app-num-anno-filter',
  templateUrl: './num-anno-filter.component.html',
  styleUrls: ['./num-anno-filter.component.scss']
})
export class NumAnnoFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listYearFilter: any;
  getAllNumAnnoSubscribe: Subscription;

  @Input() numAnnoSelected: any;

  constructor(private annoService: NumAnnoMeseService) {
    super();
  }

  ngOnInit() {
    this.getAll();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('numAnnoData' in changes) {
      this.optionSelected = this.listYearFilter ? this.listYearFilter[0] : null;
    }
    if (this.numAnnoSelected) {
      this.optionSelected = this.numAnnoSelected;
    }
  }

  getAll() {
    this.getAllNumAnnoSubscribe = this.annoService.getAllYear(new ContractTypeModel())
      .subscribe(
        (result: any) => {
          this.listYearFilter = result;
        });
  }

  compareObjects(o1: any, o2: any) {
    if (o2 === undefined || o2 ===  null) {
      return false;
    }
    return o1 === o2;
  }

  reset() {
    this.optionSelected = null;
  }

  ngOnDestroy(): void {
  }

}
